export default {
  chatWidget: {
    chatWithUs: '联系我们',
    welcomeTitle: '欢迎来到 Bookivo!',
    welcomeMessage: '今天有什么可以帮助您的吗?',
    continueChat: '继续对话',
    startConversation: '开始对话',
    formTitle: '请告诉我们更多关于您的信息',
    namePlaceholder: '您的姓名',
    emailPlaceholder: '您的邮箱',
    phonePlaceholder: '您的电话号码',
    nameRequired: '请输入您的姓名',
    emailRequired: '请输入您的邮箱',
    emailInvalid: '请输入有效的邮箱地址',
    phoneRequired: '请输入您的电话号码',
    startChat: '开始聊天',
    chatTitle: '客服对话',
    chatTitleNoAgent: '连接中...',
    endChat: '结束会话',
    inputPlaceholder: '输入您的消息...',
    greeting: '您好',
    greetingMessage: '今天有什么可以帮助您的吗?',
    emoji: '表情',
    uploadImage: '上传图片',
    sending: '发送中...',
    uploadFailed: '上传失败，请重试',
    fileTooLarge: '文件大小不能超过10MB',
    invalidFileType: '只能上传图片文件',
    sendFailed: '消息发送失败，请重试',
    imageSendFailed: '图片发送失败，请重试',
    connectionLost: '连接已断开，请关闭聊天窗口重新连接',
    uploading: '正在上传图片...',
    sessionEnded: '会话已结束',
    rating: {
      title: '感谢您使用我们的服务，请为此次服务进行评价！',
      satisfied: '满意',
      dissatisfied: '不满意',
      placeholder: '欢迎为我们的服务提建议',
      submit: '提交评价',
      endChat: '立即结束',
      backToChat: '返回聊天',
      success: '感谢您的反馈！'
    }
  },
  imServer: {
    systemName: '分销融合',
    online: '在线',
    offline: '离线',
    noSession: '当前没有会话'
  },
  imClient: {
    chatWithUs: '咨询客服',
    connecting: '连接中...',
    chattingWithAgent: '您正在与客服{agentName}对话',
    endConversation: '结束本次对话？',
    endSession: '结束会话',
    cancel: '取消',
    continueConsult: '继续咨询',
    sessionEnded: '本次会话已结束',
    leave: {
      title: '当前人工客服不在线，如需帮助请留言',
      phonePlaceholder: '手机(必填)',
      emailPlaceholder: '邮箱(必填)',
      contentPlaceholder: '请输入2-100字符',
      submit: '提交',
      successTitle: '留 言 提 交 成 功',
      successSubtitle: '我们会很快与您联系',
      emailError: '请输入正确的邮箱',
      phoneError: '请输入正确的电话号码',
      contentError: '请输入2-100个字符'
    },
    rate: {
      title: '感谢您使用我们的服务，请为此次服务进行评价!',
      satisfied: '满意',
      dissatisfied: '不满意',
      suggestionPlaceholder: '欢迎为我们的服务提建议',
      submit: '提交评价',
      endNow: '立即结束',
      backToChat: '回到会话',
      success: '评价提交成功'
    },
    transfer: {
      startConsult: '开始咨询'
    }
  },
  common: {
    emoji: '表情',
    image: '图片',
    uploadImage: '图片',
    loadMoreHistory: '查看更多历史消息',
    noMoreHistory: '没有更多了',
    historyEnd: '——以上是历史消息——',
    system: '系统',
    assignFailMsg: '分配客服失败，请联系管理员',
    download: '下载',
    noRobotConfig: '当前没有配置机器人，',
    transferAgent: '转接客服',
    inputPlaceholder: '说点什么吧...',
    send: '发送',
    continueConsult: '继续咨询',
    close: '关闭',
    quote: '引用',
    fileSizeLimit: '文件大小不能超过10M',
    evaluation: '评价'
  }
}
